import { Cart } from '../types';

type HasMeasureInsurance = (cart: Partial<Cart> | null) => boolean;

export const hasMeasureInsurance: HasMeasureInsurance = cart =>
  cart !== null && cart.items
    ? typeof cart.items.find(
        ({ product_type }) => product_type === 'Measure Insurance',
      ) !== 'undefined'
    : false;
